/* eslint-disable jsx-a11y/accessible-emoji */
import {Box, Heading, Space, Text, VStack} from 'platform/foundation';

import {useState} from 'react';
import {Route, Routes} from 'react-router-dom';

import {browserStorageKey} from './constants/browserStorageKey';
import {DashboardPage} from './pages/DashboardPage/DashboardPage';
import {LoginPage} from './pages/LoginPage/LoginPage';
import {UserContext} from './utils/UserContext';

export function App() {
  const [token, setToken] = useState<string | null>(() =>
    sessionStorage.getItem(browserStorageKey.ACCESS_TOKEN)
  );

  const isUserLogged = !!token;

  return (
    <UserContext.Provider value={[token, setToken]}>
      <Box padding={16}>
        <VStack align="center">
          <Heading size={2}>🏫</Heading>
          <Heading size={2}>Academy</Heading>
          <Text>Educational resources</Text>
          <Space vertical={20} />
          <Box width="100%" maxWidth={300}>
            <Routes>
              {isUserLogged && (
                <>
                  <Route path="/" element={<DashboardPage />} />
                </>
              )}
              <Route path="*" element={<LoginPage />} />
            </Routes>
          </Box>
        </VStack>
      </Box>
    </UserContext.Provider>
  );
}
